<div
    [ngClass]="{
        'tournament-filters': true,
        'tournament-filters--expanded': filterMobileExpanded,
        'tournament-filters--collapsed': !filterMobileExpanded
    }"
>
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <h4 class="h6 m-0 position-relative">
                Filtros
                <nb-badge
                    [text]="activeFiltersLength"
                    [status]="activeFiltersLength > 0 ? 'success' : 'basic'"
                ></nb-badge>
            </h4>
            <button
                nbButton
                size="tiny"
                class="d-block d-lg-none ml-3"
                (click)="filterMobileExpanded = !filterMobileExpanded"
            >
                <nb-icon
                    [icon]="filterMobileExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                    style="vertical-align: middle"
                ></nb-icon>
                <span *ngIf="filterMobileExpanded">{{ "GENERAL.FILTER-COLLAPSE" | translate }}</span>
                <span *ngIf="!filterMobileExpanded">{{ "GENERAL.FILTER-EXPAND" | translate }}</span>
            </button>
        </div>
        <button
            nbButton
            ghost
            status="danger"
            size="small"
            (click)="onFilterChange({ value: null, loadStart: null, type: null })"
        >
            {{ "GENERAL.FILTER-CLEAR" | translate }}
        </button>
    </div>
    <hr class="divider" />
    <div class="tournament-filters__block" *ngFor="let filter of filterList; let index = index">
        <h5 class="subtitle">{{ filter.label.toLowerCase() }}</h5>
        <ng-container [ngSwitch]="filter.type">
            <ng-container *ngSwitchCase="1">
                <nb-radio-group
                    class="d-flex flex-wrap"
                    [name]="filter.key + '-' + index"
                    (valueChange)="onFilterChange({ value: $event, loadStart: filter.key, type: filter.type })"
                >
                    <nb-radio
                        [value]="option.id"
                        [ngClass]="[filter.key === 'local' ? 'col-12' : 'col-auto']"
                        [checked]="option.selected"
                        *ngFor="let option of filter.list"
                    >
                        {{ option.description }}
                    </nb-radio>
                </nb-radio-group>
            </ng-container>
            <ng-container *ngSwitchCase="2">
                <div class="row">
                    <div
                        [ngClass]="[
                            filter.key === 'situationId' ? 'col-12' : 'align-items-start col-6 col-md-4 col-lg-6'
                        ]"
                        *ngFor="let option of filter.list"
                    >
                        <nb-checkbox
                            [checked]="option.selected"
                            (checkedChange)="
                                onFilterChange({
                                    value: option.id,
                                    loadStart: filter.key,
                                    type: filter.type,
                                    checked: $event
                                })
                            "
                        >
                            {{ option.description }}
                        </nb-checkbox>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <hr class="divider" *ngIf="index + 1 < filterList.length" />
    </div>
</div>
